export const partitionArray = <T>(a: T[], filterFunction: (item: T) => boolean): [pass: T[], fail: T[]] =>
	a.reduce(
		([pass, fail], element) => (filterFunction(element) ? [[...pass, element], fail] : [pass, [...fail, element]]),
		[[], []]
	);
